import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import SearchInput from 'components/forms/SearchInput';
import { getMentions } from 'redux/actions/coverageActions';

import { resultsToOptions } from 'utils/misc';


const NotesFilter = ({ value, onChange, ...props }) => {
  const handleLoadOptions = async (filterString) => {
    const data = await props.getMentions({ notes: filterString });
    return resultsToOptions(data.results, 'article_title') || [];
  };

  return (
    <SearchInput
      isMulti
      placeholder="Notes"
      value={value}
      onChange={onChange}
      cacheOptions
      defaultOptions
      loadOptions={handleLoadOptions}
    />
  );
};

NotesFilter.propTypes = {
  value: PropTypes.shape({}).isRequired,
  onChange: PropTypes.func.isRequired,
  notes: PropTypes.shape({
    results: PropTypes.shape({}.isRequired),
  }).isRequired,
  getMentions: PropTypes.func.isRequired,
};

export default compose(connect(
  state => ({
    notes: state.notes,
    user: state.user,
  }),
  { getMentions },
))(NotesFilter);
